// Popüler 150 liman – TR limanları ve dünya çapında genişletilmiş
const popularPorts = [
    { name: 'Shanghai',        country: 'China',              unloc: 'CNSHA' },
    { name: 'Singapore',       country: 'Singapore',          unloc: 'SGSIN' },
    { name: 'Ningbo-Zhoushan', country: 'China',              unloc: 'CNNGB' },
    { name: 'Shenzhen',        country: 'China',              unloc: 'CNSZX' },
    { name: 'Guangzhou',       country: 'China',              unloc: 'CNGGZ' },
    { name: 'Busan',           country: 'South Korea',        unloc: 'KRPUS' },
    { name: 'Qingdao',         country: 'China',              unloc: 'CNTAO' },
    { name: 'Hong Kong',       country: 'Hong Kong',          unloc: 'HKHKG' },
    { name: 'Tianjin',         country: 'China',              unloc: 'CNTJN' },
    { name: 'Rotterdam',       country: 'Netherlands',        unloc: 'NLRTM' },
    { name: 'Jebel Ali',       country: 'UAE',                unloc: 'AEJEA' },
    { name: 'Port Klang',      country: 'Malaysia',           unloc: 'MYPKG' },
    { name: 'Xiamen',          country: 'China',              unloc: 'CNXMN' },
    { name: 'Antwerp-Bruges',  country: 'Belgium',            unloc: 'BEANR' },
    { name: 'Tanjung Pelepas', country: 'Malaysia',           unloc: 'MYTPP' },
    { name: 'Kaohsiung',       country: 'Taiwan',             unloc: 'TWKHH' },
    { name: 'Dalian',          country: 'China',              unloc: 'CNDLC' },
    { name: 'Los Angeles',     country: 'USA',                unloc: 'USLAX' },
    { name: 'Hamburg',         country: 'Germany',            unloc: 'DEHAM' },
    { name: 'New York–NJ',     country: 'USA',                unloc: 'USNYC' },
    { name: 'Long Beach',      country: 'USA',                unloc: 'USLGB' },
    { name: 'Tanger-Med',      country: 'Morocco',            unloc: 'MATNG' },
    { name: 'Laem Chabang',    country: 'Thailand',           unloc: 'THLCH' },
    { name: 'Ho Chi Minh',     country: 'Vietnam',            unloc: 'VNSGN' },
    { name: 'Jakarta',         country: 'Indonesia',          unloc: 'IDTPK' },
    { name: 'Santos',          country: 'Brazil',             unloc: 'BRSSZ' },
    { name: 'Colombo',         country: 'Sri Lanka',          unloc: 'LKCMB' },
    { name: 'Manila',          country: 'Philippines',        unloc: 'PHMNL' },
    { name: 'Valencia',        country: 'Spain',              unloc: 'ESVLC' },
    { name: 'Felixstowe',      country: 'United Kingdom',     unloc: 'GBFXT' },
    { name: 'Ambarlı',         country: 'Türkiye',             unloc: 'TRAMB' },
    { name: 'İzmir (Alsancak)',country: 'Türkiye',             unloc: 'TRIZM' },
    { name: 'Mersin',          country: 'Türkiye',             unloc: 'TRMER' },
    { name: 'İskenderun',      country: 'Türkiye',             unloc: 'TRISK' },
    { name: 'Aliğa (Nemrut)',  country: 'Türkiye',             unloc: 'TRALI' },
    { name: 'Haydarpaşa',      country: 'Türkiye',             unloc: 'TRHAY' },
    { name: 'Tekirdağ',        country: 'Türkiye',             unloc: 'TRTEK' },
    { name: 'Gemlik',          country: 'Türkiye',             unloc: 'TRGEM' },
    { name: 'Samsun',          country: 'Türkiye',             unloc: 'TRSSX' },
    { name: 'Derince',         country: 'Türkiye',             unloc: 'TRDER' },
    { name: 'Algeciras',       country: 'Spain',              unloc: 'ESALG' },
    { name: 'Piraeus',         country: 'Greece',             unloc: 'GRPIR' },
    { name: 'Savannah',        country: 'USA',                unloc: 'USSAV' },
    { name: 'Port Said',       country: 'Egypt',              unloc: 'EGPSD' },
    { name: 'Durban',          country: 'South Africa',       unloc: 'ZADUR' },
    { name: 'Vancouver',       country: 'Canada',             unloc: 'CAVAN' },
    { name: 'Apapa (Lagos)',   country: 'Nigeria',            unloc: 'NGAPP' },
    { name: 'Veracruz',        country: 'Mexico',             unloc: 'MXVER' },
    { name: 'Sydney (Botany)', country: 'Australia',          unloc: 'AUBTN' },
    { name: 'Melbourne',       country: 'Australia',          unloc: 'AUMEB' },
    { name: 'Trabzon',         country: 'Türkiye',             unloc: 'TRTRB' },
    { name: 'Bandırma',        country: 'Türkiye',             unloc: 'TRBDM' },
    { name: 'Antalya',         country: 'Türkiye',             unloc: 'TRAYT' },
    { name: 'Çanakkale',       country: 'Türkiye',             unloc: 'TRCKZ' },
    { name: 'Zonguldak',       country: 'Türkiye',             unloc: 'TRZON' },
    { name: 'Rize',            country: 'Türkiye',             unloc: 'TRRZE' },
    { name: 'Filyos',          country: 'Türkiye',             unloc: 'TRFLY' },
    { name: 'Tuzla',           country: 'Türkiye',             unloc: 'TRTUZ' },
    { name: 'Çeşme',           country: 'Türkiye',             unloc: 'TRCES' },
    { name: 'İnebolu',         country: 'Türkiye',             unloc: 'TRINE' },
    { name: 'Bremerhaven',     country: 'Germany',            unloc: 'DEBRV' },
    { name: 'Gioia Tauro',     country: 'Italy',              unloc: 'ITGIT' },
    { name: 'King Abdullah',   country: 'Saudi Arabia',       unloc: 'SAKAP' },
    { name: 'Khalifa',         country: 'UAE',                unloc: 'AEKHL' },
    { name: 'Lianyungang',     country: 'China',              unloc: 'CNLYG' },
    { name: 'Yingkou',         country: 'China',              unloc: 'CNYIK' },
    { name: 'Tokyo',           country: 'Japan',              unloc: 'JPTYO' },
    { name: 'Yokohama',        country: 'Japan',              unloc: 'JPYOK' },
    { name: 'Kobe',            country: 'Japan',              unloc: 'JPKOB' },
    { name: 'Nagoya',          country: 'Japan',              unloc: 'JPNGO' },
    { name: 'Chittagong',      country: 'Bangladesh',         unloc: 'BDCGP' },
    { name: 'Karachi',         country: 'Pakistan',           unloc: 'PKKHI' },
    { name: 'Le Havre',        country: 'France',             unloc: 'FRLEH' },
    { name: 'Fos-sur-Mer',     country: 'France',             unloc: 'FRFOS' },
    { name: 'Genoa',           country: 'Italy',              unloc: 'ITGOA' },
    { name: 'La Spezia',       country: 'Italy',              unloc: 'ITSPZ' },
    { name: 'Barcelona',       country: 'Spain',              unloc: 'ESBCN' },
    { name: 'Sines',           country: 'Portugal',           unloc: 'PTSIE' },
    { name: 'Dunkirk',         country: 'France',             unloc: 'FRDKR' },
    { name: 'Haifa',           country: 'Israel',             unloc: 'ILHFA' },
    { name: 'Ashdod',          country: 'Israel',             unloc: 'ILASH' },
    { name: 'Port Sudan',      country: 'Sudan',              unloc: 'SDPZU' },
    { name: 'Mombasa',         country: 'Kenya',              unloc: 'KEMBA' },
    { name: 'Dar es Salaam',   country: 'Tanzania',           unloc: 'TZDAR' },
    { name: 'Abidjan',         country: 'Côte d’Ivoire',      unloc: 'CIABJ' },
    { name: 'Tema',            country: 'Ghana',              unloc: 'GHTEM' },
    { name: 'Itajaí',          country: 'Brazil',             unloc: 'BRITJ' },
    { name: 'Rio de Janeiro',  country: 'Brazil',             unloc: 'BRRIO' },
    { name: 'Buenos Aires',    country: 'Argentina',          unloc: 'ARBUE' },
    { name: 'Callao',          country: 'Peru',               unloc: 'PECLL' },
    { name: 'Valparaíso',      country: 'Chile',              unloc: 'CLVAP' },
    { name: 'Auckland',        country: 'New Zealand',        unloc: 'NZAKL' },
    { name: 'Tauranga',        country: 'New Zealand',        unloc: 'NZTRG' },
    { name: 'Chennai',         country: 'India',              unloc: 'INMAA' },
    { name: 'Nhava Sheva',     country: 'India',              unloc: 'INNSA' },
    { name: 'Mundra',          country: 'India',              unloc: 'INMUN' },
    { name: 'Incheon',         country: 'South Korea',        unloc: 'KRINC' },
    { name: 'Vladivostok',     country: 'Russia',             unloc: 'RUVVO' },
    { name: 'Port Qasim',      country: 'Pakistan',           unloc: 'PKBQM' },
    { name: 'Maputo',          country: 'Mozambique',         unloc: 'MZMPM' },
    { name: 'Nouakchott',      country: 'Mauritania',         unloc: 'MRNKC' },
    { name: 'Djibouti',        country: 'Djibouti',           unloc: 'DJJIB' },
    { name: 'Muscat (Sohar)',  country: 'Oman',               unloc: 'OMSOH' },
    { name: 'Salalah',         country: 'Oman',               unloc: 'OMSLL' },
    { name: 'San Pedro',       country: 'Côte d’Ivoire',      unloc: 'CISPE' },
    { name: 'Libreville',      country: 'Gabon',              unloc: 'GALBV' },
    { name: 'Georgetown',      country: 'Guyana',             unloc: 'GYGEO' },
    { name: 'Puerto Limon',    country: 'Costa Rica',         unloc: 'CRLIO' },
    { name: 'Houston',         country: 'USA',                unloc: 'USHOU' },
    { name: 'Seattle-Tacoma',  country: 'USA',                unloc: 'USSEA' },
    { name: 'Philadelphia',    country: 'USA',                unloc: 'USPAT' },
    { name: 'San Diego',       country: 'USA',                unloc: 'USSAN' },
    { name: 'Osaka',           country: 'Japan',              unloc: 'JPOSA' },
    { name: 'Kaohsiung 2',     country: 'Taiwan',             unloc: 'TWTPE' }
];

export default popularPorts;
